import React from "react"
import { css } from "@emotion/core"

import * as dsm from "../../../utils/dsm"
import * as mixins from "../../../utils/mixins"

import PlanningIcon from "../../svgs/PlanningLight"
import MethodsIcon from "../../svgs/MethodsLight"
import HydroseedingIcon from "../../svgs/HydroseedingLight"
import InspectionsIcon from "../../svgs/InspectionsLight"

export function ServiceTitleBanner({
  children,
  styles = "",
  icon,
  containerStyles = "",
  textStyles = "",
  iconStyles = "",
}) {
  return (
    <div
      css={css`
        width: 100%;
        display: flex;
        justify-content: center;
        background: ${dsm.colors.greenGradient.base};
        padding: 0.65rem ${horizontalPadding};
        z-index: 9;
        ${dsm.colors.boxShadow};

        ${mixins.device.mobileM} {
          padding: 0.75rem;
        }

        ${mixins.device.tablet} {
          display: none;
        }

        ${containerStyles}
      `}
    >
      <IconContainer icon={icon} iconStyles={iconStyles} />
      <h2
        css={css`
          margin: 0;
          margin-left: 0.85rem;
          ${dsm.fonts.display}
          ${dsm.fonts.textShadow.black}
          color: white;
          font-size: 1.25rem;

          ${mixins.device.mobileM} {
            font-size: 1.35rem;
          }

          ${mixins.device.mobileX} {
            font-size: 1.45rem;
          }

          ${styles}
          ${textStyles}
        `}
      >
        {children}
      </h2>
    </div>
  )
}

function IconContainer({ icon = "", styles = "" }) {
  return (
    <div
      css={css`
        position: relative;
        width: 1.25rem;
        height: 1.25rem;

        ${styles}
      `}
    >
      {icon}
    </div>
  )
}

var horizontalPadding = `0.75rem`

export function ESCPlanningTitle({ containerStyles, iconStyles }) {
  return (
    <ServiceTitleBanner
      containerStyles={containerStyles}
      icon={
        <PlanningIcon
          styles={css`
            position: absolute;
            right: -0.2rem;
          `}
          iconStyles={iconStyles}
        />
      }
    >
      SITE PLANNING
    </ServiceTitleBanner>
  )
}
export function MethodsTitle({ containerStyles, iconStyles }) {
  return (
    <ServiceTitleBanner
      containerStyles={containerStyles}
      styles={css`
        margin-left: 0.9rem;
      `}
      icon={
        <MethodsIcon
          styles={css`
            bottom: -0.05rem;
            position: absolute;
          `}
          iconStyles={iconStyles}
        />
      }
    >
      LANDSCAPING
    </ServiceTitleBanner>
  )
}

export function HydroseedingTitle({ containerStyles, iconStyles }) {
  return (
    <ServiceTitleBanner
      containerStyles={containerStyles}
      icon={<HydroseedingIcon iconStyles={iconStyles} />}
    >
      MAINTENANCE
    </ServiceTitleBanner>
  )
}

export function InspectionsTitle({ containerStyles, iconStyles }) {
  return (
    <ServiceTitleBanner
      containerStyles={containerStyles}
      icon={<InspectionsIcon iconStyles={iconStyles} />}
    >
      REVEGETATION
    </ServiceTitleBanner>
  )
}
